export default __webpack_public_path__ + "static/media/antelope-11-thumbnail.2a2a49b2.webp";